<template>
  <div>
    <section class="xbed-sub-title">
      <span>业主营收报表</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>报表</BreadcrumbItem>
        <BreadcrumbItem>业主营收报表</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <Tabs class="tabs add-distance" @on-click="toggleTab">
      <TabPane label="房间月度营收" name="roomList" ref="roomList">
        <rooms-revenue 
        ref="roomsRevenue"
        :yearMonthDate="yearMonthDate"
        :roomsData="roomsData" 
        @isShowModify="showHiddenModify"
        @queryReportData="queryRoomsMonthIncomeList"/>
      </TabPane>
      <TabPane label="业主月度营收" name="ownerList" ref="ownerList">
        <owner-revenue ref="ownerRevenue" :roomsData="ownerData" :yearMonthDate="yearMonthDate" @queryReportData="queryOwnerRoomsMonthList"/>
      </TabPane>
    </Tabs>

    <!-- Modal 内容 -->
    <Modal v-model="editRoomPriceModal.display" title="修改房间月账单导入金额" :loading="true" @on-ok="saveModify" @on-cancel="saveModify" width="640">
      <edit-room-money :modifyParams="modifyParams"/>
    </Modal>
  </div>
</template>

<script>
import OwnerRevenue from './owner-revenue'
import RoomsRevenue from './rooms-revenue'
import EditRoomMoney from './edit-room-money'
import Utils from "../../../utils";
import API from "../../../api";

export default {

  data () {
    return {
      // 修改房间月账单 modal
      editRoomPriceModal: {
        display: false,
        data: {}
      },
      // 房间月账单
      roomsData:{},
      // 业主月账单
      ownerData:{},
      // 当前标签页   0房间月度营收， 1业主月度营收
      activeTagPage: 0,
      // 修改的对象
      modifyParams: {},
      // 年月日
      yearMonthDate: [],
      // 是否加载过另一tag页的数据
      isLoadTagData: false,
      // 存储查询的对象
      queryForm:{}
    }
  },

  methods: {
    //切换标签页
    toggleTab (tabName) {
      if( tabName === 0 ){
        this.activeTagPage = 1;
      }else{
        this.activeTagPage = 0
      }
      if( !this.isLoadTagData ){
        this.isLoadTagData = true;
        this.$refs.ownerRevenue.quertReport();
      }
    },
    
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },

    //显示或隐藏修改窗口
    showHiddenModify(params){
      this.editRoomPriceModal.display = !this.editRoomPriceModal.display;
      this.modifyParams = params;
    },

    //保存修改
    saveModify(){
      this.editRoomPriceModal.display = !this.editRoomPriceModal.display;
      this.queryRoomsMonthIncomeList();
    },

    //查询房间报表
    async queryRoomsMonthIncomeList (params, callback){
      if( !params ){
        params = this.queryForm;
      }else{
        this.queryForm = params;
      }
      try{
        const responData = await API.omsAPI[this.env].report.queryRoomsMonthIncomeList(params, this.token);
        this.roomsData = responData.data;
        callback && callback();
      }catch(e){
        console.info(e)
      }
    },

    //查询业主报表
    async queryOwnerRoomsMonthList (params, callback){
        
      try{
        const responData = await API.omsAPI[this.env].report.queryOwnerRoomsMonthList(params, this.token);
        this.ownerData = responData.data;
        console.info(this.ownerData)
        callback && callback();
      }catch(e){
        console.info(e)
      }
    },

    // 获取年月
    getYearMonth(){
      return new Promise(async (resolve, reject) => {
        try{
          const responData = await API.omsAPI[this.env].report.queryYearMouth(this.token);
          this.yearMonthDate = responData.data;
          console.info(this.yearMonthDate);
          resolve()
        }catch(e){
          console.info(e)
          reject()
        }
      })
    },
  },
  components: {
    'owner-revenue': OwnerRevenue,
    'rooms-revenue': RoomsRevenue,
    'edit-room-money': EditRoomMoney
  },
  async mounted(){
    // this.queryRoomsMonthIncomeList();
    await this.getYearMonth();
    this.$refs.roomsRevenue.quertReport();
  },
  async created () {
    this.token = Utils.findFromLocalStorage("vue-token"); 
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  margin-top: 20px;
}

.add-distance {
  margin-top: 10px;
}
</style>





// WEBPACK FOOTER //
// src/pages/report/owner-revenue/index.vue